(function ($, njm) {
    'use strict';

    njm.views.cssLogin = Backbone.View.extend({

        events: {
            'click #login1': 'login1',
            'click #login2': 'login2',
            'click #cancel': 'backToSection',
            'click #cancelReset': 'cancelReset',
            'click #forgotAnswers': 'forgotAnswers',
            'click #login3': 'verifyCodeEvent',
            'click #createQuestionsCancel': 'backToSection',
            'click #login4': 'updateQuestions',
            'click .password-visibility': 'passwordVisibility',
            'keypress #password': 'capslockHint'
        },
         
        initialize: function () {
            try {
                var destinationUrl = $('#login1').data('destinationurl'),
                locCheck = decodeURIComponent(window.location.search),
                timestamp = this.urlParam('_dc', locCheck);

                if (!this.urlParam("goto") || (!document.referrer && !timestamp) || (!document.referrer && timestamp && ((Date.now() - timestamp) / 60000 >= 5))) {
                    this.redirect(destinationUrl + '?_dc=' + Date.now());
                }
                var me = this;
                setInterval(function () {
                    if (!timestamp || (Date.now() - timestamp) / 60000 >= 5) {
                        me.redirect(destinationUrl + '?_dc=' + Date.now());
                    }
                }, 300000);

                if (window.location.href.indexOf('vercd') >= 0) {
                    this.verifyCode(window.location.href.split('vercd')[1].substring(1));
                } else {
                    $('#userid').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                    $('#password').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login1').click();
                        }
                    });
                    $('#ans1').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login2').click();
                        }
                    });
                    $('#ans2').keypress(function (e) {
                        if (e.keyCode === 13) {
                            $('#login2').click();
                        }
                    });
                }

                if (localStorage.Csschkbox && localStorage.Csschkbox != '') {
                    $('#rememberUserID').attr('checked', 'checked');
                    $('#userid').val(localStorage.Cssusername);
                } else {
                    $('#rememberUserID').removeAttr('checked');
                    $('#userid').val('');
                }

                /**
                * Disable IE's capslock indicator since we provide one
                **/
                if ($('.cssLogin #password') && document.msCapsLockWarningOff === false) {
                    document.msCapsLockWarningOff = true;
                }

                /**
                * Prevent selecting duplicate security questions
                **/
                $(".securityQuestion").change(function () {
                    var values = [];

                    $(".securityQuestion").each(function () {
                        values.push(this.value);
                    });

                    $(this).parent().siblings(".questionContainer").children(".securityQuestion").find("option").removeAttr("disabled").filter(function () {
                        var a = $(this).parent("select").val();
                        return (($.inArray(this.value, values) > -1) && (this.value !== a));
                    }).attr("disabled", "disabled");
                });

                /**
                * Trigger prevention of duplicate security questions
                **/
                $(".securityQuestion").eq(0).trigger('change');
                njmClientClickTracking.trackPageName(window.location.href, document.referrer);
            }
            catch (ex) {
                njmClientClickTracking.logErrorGeneric("initialize", ex.name, "Exception on initialize", "Anonymous", ex.stack);
                throw ex;
            }
        },

        stringTrim: function (x) {
            return x.replace(/^\s+|\s+$/gm, '');
        },

        /**
        * Parse return error message for Login
        **/
        checkLoginError: function (response) {
            var status = response.status,
                msg = response.responseText ? JSON.parse(response.responseText).message : '';
            var userId = this.stringTrim(document.getElementById('userid').value);
            var errorMsg = 'We’re sorry, an error has occurred. Please try again later.';

            if (status === 400 && msg) {
                if (msg.indexOf('Authentication Failed') >= 0) {
                    errorMsg = 'The User ID and/or Password you are entering are invalid.';
                    if (msg.indexOf('You will be locked out') >= 0) {
                        errorMsg = errorMsg + ' To avoid being locked out, please use the “Forgot User ID?” and/or “Forgot Password?” links to obtain your User ID or a new Password.';
                    }
                } else if (msg.indexOf('Your account has been locked') >= 0) {
                    errorMsg = 'You have been locked out of your account. Please contact our customer service department during our business hours.';
                } else if (msg.indexOf('Your account is locked') >= 0) {
                    errorMsg = 'Your account is locked. Please contact our Customer Service department during our business hours.';
                } else if (msg.indexOf('You have not successfully completed your registration') >= 0) {
                    errorMsg = 'You have not successfully completed your registration. Please click the link in the e-mail we have sent you to complete the registration process or contact our Customer Service department during our business hours.';
                } else if (msg.indexOf('Your account has been deactivated') >= 0) {
                    errorMsg = 'Your account has been deactivated. Please contact our Customer Service department during our business hours.';
                } else {
                    errorMsg = 'The User ID and/or Password you are entering are invalid.';
                }
            }
            njmClientClickTracking.logErrorGeneric("checkLoginError", msg, status, userId, errorMsg);
            return errorMsg;
        },

        /**
        * Redirects to given location. Handles Cancel and Registration button clicks
        **/
        cancelReset: function (e) {
            var destinationUrl = $(e.currentTarget).data('href');

            if (destinationUrl !== undefined && destinationUrl !== '') {
                window.location = destinationUrl;
            }
        },

        /**
        * In future, needs to get URL from API return in previous step as parameter
        * In future, needs to get URL from API return in previous step as parameter
        **/
        redirect: function (inpurl) {
            if (window.location.search.indexOf('mobile=y') >= 0) {
                inpurl = inpurl + '?mobile=y';
            }
            window.location.replace(inpurl);
        },

        login1: function (e) {
            e.preventDefault();
            $('#loading').show();

            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);


            var loginApiUrl = $(e.currentTarget).data('loginapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');

            this.login(loginApiUrl, destinationUrl, false);
        },

        /**
        * Passes question answers and save device choice to login/save API
        * Redirects on success
        **/
        login2: function (e) {
            e.preventDefault();
            var self = this;

            $('#loading').show();
            var UserId = document.getElementById('userid').value;
            var OauthUrl = $('#login2').data('oauthurl');
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            var ans1 = this.stringTrim(document.getElementById('ans1').value),
                ans2 = this.stringTrim(document.getElementById('ans2').value),
                valid = true;

            var loginApiUrl = $(e.currentTarget).data('loginapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');
            var saveApiUrl = $(e.currentTarget).data('saveapiurl');

            if (this.stringTrim(ans1) === '') {
                document.getElementById('ans1').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('ans1').style.border = '';
            }

            if (this.stringTrim(ans2) === '') {
                document.getElementById('ans2').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('ans2').style.border = '';
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else {
                $.ajax({
                    type: 'POST',
                    url: saveApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        'Answer1': document.getElementById('ans1').value,
                        'Answer2': document.getElementById('ans2').value,
                        'Save': document.getElementById('saveDevice').checked
                    },
                    success: function (response, status, request) {
                        document.getElementById('warning').style.display = 'none';
                        $('#loading').hide();
                        self.sendUserAnalytics(response, document.getElementById('login2'));
                        self.getOauthToken(destinationUrl, OauthUrl, self);
                        //self.redirect(request, destinationUrl);
                    },
                    error: function (response) {
                        document.getElementById('ans1').value = '';
                        document.getElementById('ans2').value = '';
                        var error = self.checkKBAError(response.status, JSON.parse(response.responseText).message);
                        document.getElementById('warningText').innerHTML = error;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        if (error.indexOf('You have been locked out of your account.') < 0) {
                            self.login(loginApiUrl, destinationUrl, true);
                        }
                    }
                });
            }
        },

        login: function (loginApiUrl, destinationUrl, keepWarning) {
            var self = this;
            var OauthUrl = $('#login2').data('oauthurl');
            var userID = this.stringTrim(document.getElementById('userid').value),
                pass = this.stringTrim(document.getElementById('password').value),
                valid = true;
            if (document.getElementById("rememberUserID").checked) {
                // save username and password
                localStorage.Cssusername = userID;
                localStorage.Csschkbox = document.getElementById("rememberUserID").checked;
            } else {
                localStorage.Cssusername = '';
                localStorage.Csschkbox = '';
            }

            if (this.stringTrim(userID) === '') {
                document.getElementById('userid').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('userid').style.border = '';
            }

            if (this.stringTrim(pass) === '') {
                document.getElementById('password').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('password').style.border = '';
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else {
                $.ajax({
                    type: 'POST',
                    url: loginApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        'UserID': userID,
                        'Password': pass,
                        'device': device()
                    },
                    success: function (response, status, request) {
                        if (Array.isArray(response)) {
                            if (response.length === 2) {
                                document.getElementById('question1').innerHTML = response[0];
                                document.getElementById('question2').innerHTML = response[1];
                                document.getElementById('login-box').style.display = 'none';
                                document.getElementById('answerQuestions').style.display = 'block';
                                njmClientClickTracking.screenLoadingsuccessful("answerQuestions", userID);

                            } else {
                                self.fillQuestions(response);
                                document.getElementById('login-box').style.display = 'none';
                                document.getElementById('createQuestions').style.display = 'block';

                                $('#createQuestionsCancel').attr('data-backsection', 'login-box');
                            }
                        } else {
                            self.sendUserAnalytics(response, document.getElementById('login1'));
                            self.getOauthToken(destinationUrl, OauthUrl, self);
                            //self.redirect(request, destinationUrl);
                        }

                        if (!keepWarning) {
                            document.getElementById('warning').style.display = 'none';
                        }
                        $('#loading').hide();
                    },
                    error: function (response) {
                        var errorResponse = self.checkLoginError(response);
                        document.getElementById('warningText').innerHTML = errorResponse;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        if (!document.getElementById("rememberUserID").checked) {
                            document.getElementById('userid').value = '';
                        }
                        document.getElementById('password').value = '';

                    }
                });
            }
        },

        /**
        * Parse return error message for KBA
        **/
        checkKBAError: function (status, msg) {
            var errorMsg = 'We’re sorry, an error has occurred. Please try again later.';
            var userId = this.stringTrim(document.getElementById('userid').value);
            if (status === 400) {
                if (msg.indexOf('Your account has been locked') >= 0) {
                    errorMsg = 'You have been locked out of your account. Please contact our customer service department during our business hours.';
                } else if (msg.indexOf('Your account is locked') >= 0) {
                    errorMsg = 'Your account is locked. Please contact our Customer Service department during our business hours.';
                } else {
                    errorMsg = 'The answers you have entered do not match our records. Please try again.';
                    var index = msg.indexOf('You will be locked out');
                    if (index >= 0) {
                        errorMsg = errorMsg + ' ' + msg.substring(index);
                    }
                }
            }
            njmClientClickTracking.logErrorGeneric("checkKBAError", msg, status, userId, errorMsg);
            return errorMsg;
        },

        /**
        * Calls API to send email with code to enter and brings up enter code page
        **/
        forgotAnswers: function (e) {
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            $.ajax({
                type: 'POST',
                xhrFields: {
                    withCredentials: true
                },
                url: $(e.currentTarget).data('loginapiurl'),
                data: '=' + this.stringTrim(document.getElementById('userid').value),
                success: function (response, status, request) {
                    document.getElementById('warning').style.display = 'none';
                    document.getElementById('answerQuestions').style.display = 'none';
                    document.getElementById('enterCode').style.display = 'block';
                    $('#loading').hide();
                },
                error: function (response) {
                    var msg = response.responseText ? JSON.parse(response.responseText).message : '';
                    var userId = this.stringTrim(document.getElementById('userid').value);
                    var warningText = "We’re sorry, an error has occurred. Please try again later.";
                    document.getElementById('ans1').value = '';
                    document.getElementById('ans2').value = '';
                    document.getElementById('warningText').innerHTML = 'We’re sorry, an error has occurred. Please try again later.';
                    document.getElementById('warning').style.display = 'block';
                    $('#loading').hide();
                    njmClientClickTracking.logErrorGeneric("forgotAnswers", msg, response.status, userId, warningText);
                }
            });
        },

        verifyCodeEvent: function (e) {
            var validateApiUrl = $(e.currentTarget).data('validateapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            this.verifyCode(validateApiUrl, destinationUrl);
        },

        /**
        * Sends entered code to API for verification and redirects to CSS if valid
        **/
        verifyCode: function (validateApiUrl, destinationUrl) {
            var self = this;

            $('#loading').show();
            if (document.getElementById('code').value === '') {
                document.getElementById('code').style.border = '1px solid #cc0000';
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else {
                $.ajax({
                    type: 'POST',
                    url: validateApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    //data: '=' + document.getElementById('code').value,

                    data: {
                        UserID: this.stringTrim(document.getElementById('userid').value),
                        Key: document.getElementById('code').value
                    },
                    success: function (response, status, request) {
                        document.getElementById('warning').style.display = 'none';
                        $('#loading').hide();
                        self.fillQuestions(response);
                        document.getElementById('enterCode').style.display = 'none';
                        document.getElementById('createQuestions').style.display = 'block';

                        //redirect(request, destUrl);
                    },
                    error: function (response) {
                        var msg = response.responseText ? JSON.parse(response.responseText).message : '',
                            error = msg.indexOf('Mismatch') >= 0 ? 'The Validation Code you entered is not recognized. Please check the number and try again.' :
                                msg.indexOf('Expired') >= 0 ? 'This Validation Code has expired. Please restart the security question reset process.' :
                                    'We’re sorry, an error has occurred. Please try again later.';
                        var userId = this.stringTrim(document.getElementById('userid').value);
                        document.getElementById('code').value = '';
                        document.getElementById('warningText').innerHTML = error;
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        njmClientClickTracking.logErrorGeneric("verifyCode", msg, response.status, userId, error);
                    }
                });
            }
        },

        /**
        * Calls API to update questions and redirects to portal if successful
        **/
        updateQuestions: function (e) {
            var self = this;

            var updateQuestionApiUrl = $(e.currentTarget).data('updatequestionapiurl');
            var destinationUrl = $(e.currentTarget).data('destinationurl');
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            $('#loading').show();

            var kba1 = document.getElementById('kba1').value,
                kba2 = document.getElementById('kba2').value,
                kba3 = document.getElementById('kba3').value,
                valid = true;

            if (self.stringTrim(kba1) === '') {
                document.getElementById('kba1').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('kba1').style.border = '';
            }

            if (self.stringTrim(kba2) === '') {
                document.getElementById('kba2').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('kba2').style.border = '';
            }

            if (self.stringTrim(kba3) === '') {
                document.getElementById('kba3').style.border = '1px solid #cc0000';
                valid = false;
            } else {
                document.getElementById('kba3').style.border = '';
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Please fill in the highlighted fields to continue';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
            } else if (self.validateAnswers()) {
                $.ajax({
                    type: 'POST',
                    url: updateQuestionApiUrl,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        UserID: this.stringTrim(document.getElementById('userid').value),

                        //Password: document.getElementById('password').value,
                        Question3Answer: document.getElementById('answer3').value,
                        Question2Answer: document.getElementById('answer2').value,
                        Question1Answer: document.getElementById('answer1').value,
                        Question3: document.getElementById('kba3').value,
                        Question2: document.getElementById('kba2').value,
                        Question1: document.getElementById('kba1').value
                    },
                    success: function (response, status, request) {
                        document.getElementById('warning').style.display = 'none';
                        $('#loading').hide();
                        self.redirect(destinationUrl);
                    },
                    error: function (response) {
                        var msg = response.responseText ? JSON.parse(response.responseText).message : '';
                        var errorMessage = "We’re sorry, an error has occurred. Please try again later.";
                        var userId = this.stringTrim(document.getElementById('userid').value);
                        document.getElementById('answer3').value = '';
                        document.getElementById('answer2').value = '';
                        document.getElementById('answer1').value = '';
                        document.getElementById('kba3').value = '';
                        document.getElementById('kba2').value = '';
                        document.getElementById('kba1').value = '';
                        document.getElementById('warningText').innerHTML = 'We’re sorry, an error has occurred. Please try again later.';
                        document.getElementById('warning').style.display = 'block';
                        $('#loading').hide();
                        njmClientClickTracking.logErrorGeneric("updateQuestions", msg, response.status, userId, errorMessage);
                    }
                });
            }
        },

        areUniqueAnswers: function () {
            var isValid = true;

            var answer1 = document.getElementById('answer1').value,
                answer2 = document.getElementById('answer2').value,
                answer3 = document.getElementById('answer3').value;

            this.toggleErrorBorder('answer1', false);
            this.toggleErrorBorder('answer2', false);
            this.toggleErrorBorder('answer3', false);

            if (answer1 === answer2) {
                this.toggleErrorBorder('answer1', true);
                this.toggleErrorBorder('answer2', true);
                isValid = false;
            }

            if (answer1 === answer3) {
                this.toggleErrorBorder('answer1', true);
                this.toggleErrorBorder('answer3', true);
                isValid = false;
            }

            if (answer2 === answer3) {
                this.toggleErrorBorder('answer2', true);
                this.toggleErrorBorder('answer3', true);
                isValid = false;
            }

            return isValid;
        },

        /**
        * Validate answers are not the same, not part of question and in proper format
        * Returns true if they are and false otherwise
        * Updates warning message if needed
        **/
        validateAnswers: function () {

            if (!this.areUniqueAnswers()) {
                document.getElementById('warningText').innerHTML = 'Each security question must have a unique answer.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();
                return false;
            }

            var answer1 = document.getElementById('answer1').value,
                answer2 = document.getElementById('answer2').value,
                answer3 = document.getElementById('answer3').value;

            //check if answers are valid formatting
            var regex = /^[0-9a-zA-Z]{3,25}$/, valid = true;
            if (!regex.test(answer1)) {
                this.toggleErrorBorder('answer1', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer1', false);
            }

            if (!regex.test(answer2)) {
                this.toggleErrorBorder('answer2', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer2', false);
            }

            if (!regex.test(answer3)) {
                this.toggleErrorBorder('answer3', true);
                valid = false;
            } else {
                this.toggleErrorBorder('answer3', false);
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Each answer must be 3-25 characters in length and must only use numeric characters (0-9) and/or alphabetic characters (a-z, A-Z).';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();

                return false;
            }

            //check if answer is part of question
            var question, markInvalid = false;
            for (var i = 1; i <= 3; i++) {
                question = $('#kba' + i + ' option:selected').text().toLowerCase().split(' ');
                var answer = document.getElementById('answer' + i).value.toLowerCase();

                for (var j = 0; j < question.length; j++) {
                    if (question[j].indexOf(answer) >= 0) {
                        document.getElementById('answer' + i).style.border = '1px solid #cc0000';
                        valid = false;
                        markInvalid = true;
                        break;
                    }
                }

                if (!markInvalid) {
                    document.getElementById('answer' + i).style.border = '';
                }
            }

            if (!valid) {
                document.getElementById('warningText').innerHTML = 'Your answer cannot contain wording from the security question.';
                document.getElementById('warning').style.display = 'block';
                $('#loading').hide();

                return false;
            }

            return true;
        },

        toggleErrorBorder: function (field, toggle) {
            if (toggle) {
                document.getElementById(field).style.border = '1px solid #cc0000';
            }
            else {
                document.getElementById(field).style.border = '';
            }
        },

        /**
        * Fill questions select boxes
        **/
        fillQuestions: function (questions) {
            var question, opt;

            for (var i = 1; i <= 3; i++) {
                question = document.getElementById('kba' + i);
                for (var j = 0; j < questions.length; j++) {
                    opt = document.createElement('option');
                    opt.innerHTML = questions[j].text;
                    opt.value = questions[j].number;
                    question.appendChild(opt);
                }
            }
        },

        sendUserAnalytics: function (response, loginButton) {
            var userId = this.stringTrim(document.getElementById('userid').value);
            var login2Button = document.getElementById('login2');
            console.log(JSON.stringify(response));
            //Parse Response
            if (response !== null && response.policies !== null && response.policies.length > 0) {
                var inputPolicyTypes = [];
                var policyStatus = "Active";
                response.policies.forEach(function (item) {
                    if (item !== null) {
                        policyStatus = "InActive";
                        if (item.policyStatus === 1) {
                            policyStatus = "Active";
                        }
                        var policy = {
                            "policyType": item.policyType,
                            "policyStatus": policyStatus
                        }
                        inputPolicyTypes.push(policy);
                    }
                });

                njmClientClickTracking.trackUser(loginButton, userId, inputPolicyTypes);
            }
        },

        backToSection: function (e) {
            var backSection = $(e.currentTarget).data('backsection');
            var currentSection = $(e.currentTarget).data('currentsection');

            if (backSection === 'login-box') {
                this.cancelReset(e);
                return;
            }
            var UserId = document.getElementById('userid').value;
            njmClientClickTracking.linkClickedWithUserID(e.currentTarget, UserId);

            document.getElementById("warning").style.display = "none";
            document.getElementById(currentSection).style.display = "none";
            document.getElementById(backSection).style.display = "block";
        },

        passwordVisibility: function (e) {
            var self = e.currentTarget;
            if ($(self).text() === 'Show') {
                $('.cssLogin input#password').attr('type', 'text');
                $(self).text('Hide');
            } else {
                $('.cssLogin input#password').attr('type', 'password');
                $(self).text('Show');
            }
        },

        isCapsLockOn: function (e) {
            if (e.originalEvent.getModifierState("CapsLock")) {
                return true;
            } else {
                return false;
            }
        },
        urlParam: function (name, goto) {
            var locationCheck;
            name = name.toLowerCase();

            if (!goto) {
                var location = window.location.search,
                index = location.indexOf('=');
                locationCheck = location.substring(0, index).toLowerCase() + location.substring(index);
            }
            else locationCheck = goto;

            var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                .exec(locationCheck);

            return (results !== null) ? results[1] || 0 : false;
        },
        getOauthToken: function (destUrl, OauthUrl, self) {
            var goto = "";
            if (location.href.indexOf('agent') !== -1) {
                goto = decodeURIComponent(location.href.substr(location.href.indexOf('agent'))).replace("#", "%20%25");
            }


            self.redirect(OauthUrl + goto + "&realm=/B2C_Admin/CSS_Admin/CSS_Users");
        },
        capslockHint: function (e) {
            if (this.isCapsLockOn(e) && ($('#warning').css('display') === 'block')) {
                $(".capslock-hint").css('display', 'inline-block');
            } else {
                $(".capslock-hint").css('display', 'none');
            }
        }
    });
})(jQuery, njm);
